// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image[data-v-329f4d9a],img[data-v-329f4d9a]{margin:auto}img[data-v-329f4d9a]{top:0;bottom:0;right:0;left:0;max-height:100%;max-width:100%;width:auto;height:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
